import { createContext } from 'react'
import type { UsePreferencesResult } from './hooks/usePreferences'

export const PreferencesContext = createContext<UsePreferencesResult | null>(null)
